/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_return_error_paid = () => `Je hebt voor dit ticket betaald, dus het is van jou: je kunt het houden, delen of doorverkopen. Neem contact op met de organisator als je een terugbetaling wilt.`
